<template>
  <div>
    <div class="page-event-details" :class="{ 'page-loaded': !showLoading }">
      <div class="banne-img fade-in-up" :class="{ 'animate-in': !showLoading }">
        <img :src="formData.image" alt="" />
      </div>
      <div class="p030 fade-in-up delay-1" :class="{ 'animate-in': !showLoading }">
        <div class="title-row fcc-h">
          <div class="h1">{{ formData.name }}</div>
          <div class="sub">{{ formData.assistantName }}</div>
          <div class="line"></div>
          <div class="des" style="min-height: 120px">{{ formData.ruleContent }}</div>
        </div>
      </div>

      <!-- 勋章：按 pointStatusMap 回显 成功/失败/未打卡，点击未打卡项传 hotspot.index 打卡 -->
      <div
        class="medal-list fade-in-up delay-2"
        :class="{ 'animate-in': !showLoading }"
        :style="'grid-template-columns: repeat(' + medalRowNum + ', 1fr)'"
      >
        <div
          class="item"
          v-for="(item, index) in medalTotal"
          :key="index"
          :style="{ 'animation-delay': index * 0.05 + 's' }"
        >
          <template v-if="getMedalStatus(index) === 1">
            <img
              :src="medalImgDo[index] || defaultMedalImgDo"
              alt=""
              class="medal-img"
              :style="medalImgStyles[index] || medalImgStyleObj"
            />
          </template>
          <template v-else-if="getMedalStatus(index) === 2">
            <img
              :src="medalImgErr[index] || medalImgNot[index] || defaultMedalImgNot"
              alt=""
              class="medal-img"
              :style="medalImgStyles[index] || medalImgStyleObj"
            />
          </template>
          <template v-else>
            <img
              :src="medalImgNot[index] || defaultMedalImgNot"
              alt=""
              class="medal-img"
              :class="{ 'medal-locked': !isMedalClickable(index) }"
              :style="medalImgStyles[index] || medalImgStyleObj"
              @click="showcheckInBoxFun(index)"
            />
          </template>
          <div
            v-if="isShowSingTitle && hotspots[index] && hotspots[index].title"
            class="medal-title"
          >
            {{ hotspots[index].title }}
          </div>
        </div>
      </div>

      <!-- 当前进度与核销 -->
      <div class="dk-activity-total fc-bet fade-in-up delay-3" :class="{ 'animate-in': !showLoading }">
        <div class="icon">
          <img :src="formData.product.image" alt="" />
        </div>
        <div class="txt flex1">
          <div>
            当前可核销次数：<span class="b">{{ verifyableCount || 0 }}</span>
            <span class="ljsy" @click="handleVerify">立即使用</span>
          </div>
          <div v-if="completedCount > 0">您已经集齐<span class="b">{{ completedCount }}</span>次活动</div>
        </div>
        <i class="link-arrow" v-if="verifyableCount === 0"></i>
      </div>
    </div>

    <!-- 成功/失败选择弹框（isOpenError 为 true 时先选再进入盖章） -->
    <div v-if="showSuccessFailChoice" class="checkin-overlay" @click="showSuccessFailChoice = false">
      <div class="fcc-h success-fail-choice-pop" @click.stop>
        <div class="choice-title">请选择本次打卡结果</div>
        <div class="choice-btns">
          <div class="choice-btn choice-btn-success" @click="onChooseSignSuccess(1)">成功</div>
          <div class="choice-btn choice-btn-fail" @click="onChooseSignSuccess(2)">失败</div>
        </div>
      </div>
    </div>

    <!-- 打卡盖章弹框（与 activity3-1 一致：标准 800×600 坐标系） -->
    <div v-if="showcheckInBox" class="checkin-overlay" @click="handleOverlayClick">
      <div class="fcc-h checkin-pop" @click.stop>
        <div class="canvas-container">
          <div
            ref="canvasWrap"
            class="canvas-wrap"
            @touchstart="handleTouchStart"
            @touchmove.prevent="handleTouchMove"
            @touchend="handleTouchEnd"
            @touchcancel="handleTouchEnd"
          ></div>
          <div class="checkin-hint">盖章区域</div>
        </div>
      </div>
    </div>

    <!-- 加载中 overlay -->
    <div v-if="showLoading" class="loading-overlay">
      <div class="fcc-h loading-wrapper" style="height: 100vh;">
        <div class="loading-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-logo">
            <img :src="getImageUrl('logoicon.png')" alt="" />
          </div>
        </div>
        <div class="loading-text">加载中...</div>
      </div>
    </div>

    <!-- 打卡成功旋转动画 overlay -->
    <div v-if="load" class="loading-overlay" @click="load = false">
      <div class="loading-content" @click.stop>
        <div class="brand-logo fcc seal-loading">
          <div class="seal-circle-outer">
            <img class="circle" :src="getImageUrl('8bg.png')" alt="" />
          </div>
          <div class="seal-logo-inner">
            <img :src="getImageUrl('logoicon.png')" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getSignStoreActivityDetailByCode,
  getSignStoreActivityDetail,
  validateSeal,
  getOrCreateUserRecordH5,
  getCheckedPointsWithStatus
} from '@/api/signstore'
import { getImageUrl } from '@/utils/image'
import { ensureSignstoreH5Uid } from '@/utils/signstore-h5-uid'
import { Toast } from 'vant'
import moment from 'moment'

/**
 * 活动模板 ACT002：勋章打卡页（与小程序 activity2 逻辑一致，同一配置双端使用）
 * 含：banner、标题/规则、勋章网格（成功/失败/未打卡）、底部核销卡片、成功/失败选择、盖章弹框
 */
export default {
  name: 'Activity2',
  data() {
    return {
      medalTotal: 10,
      medalRowNum: 5,
      hotspots: [],
      medalImgDo: {},
      medalImgNot: {},
      medalImgErr: {},
      defaultMedalImgDo: 'https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/images/xz2.png',
      defaultMedalImgNot: 'https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/images/xz.png',
      medalImgStyleObj: { width: '50px', height: '50px' },
      medalImgStyles: {},
      pointStatusMap: {},
      currentCheckinMedalIndex: null,
      isShowSingTitle: false,
      activityId: 0,
      activityCode: null,
      h5Uid: null,
      activityUserId: null,
      ruleCode: null,
      formData: {
        name: '',
        assistantName: '',
        ruleContent: '',
        image: '',
        product: { image: '' }
      },
      completedCount: 0,
      verifyableCount: 0,
      isVerifying: false,
      showLoading: false,
      checking: false,
      showcheckInBox: false,
      load: false,
      isOpenError: false,
      showSuccessFailChoice: false,
      chosenSignSuccess: null,
      standardWidth: 800,
      standardHeight: 600,
      lastTouchPoints: null,
      lastValidFourPoints: null,
      hasSubmittedThisGesture: false,
      retryTimer: null,
      retryCount: 0,
      maxAutoRetry: 2
    }
  },
  mounted() {
    const activityCode = this.$route.query.activity_code
    const activityId = this.$route.query.id
    const uidRaw = this.$route.query.uid != null ? String(this.$route.query.uid).trim() : ''
    if (!uidRaw) {
      this.h5Uid = ensureSignstoreH5Uid(this.$route.query.h5_uid)
    }
    if (activityCode) {
      this.activityCode = activityCode
      this.queryActiveFun()
    } else if (activityId) {
      this.activityId = activityId
      this.queryActiveFun()
    } else {
      Toast('活动不存在或已结束')
      setTimeout(() => this.$router.replace('/index'), 1500)
    }
  },
  beforeDestroy() {
    if (this.retryTimer) {
      clearTimeout(this.retryTimer)
      this.retryTimer = null
    }
  },
  methods: {
    getImageUrl,
    async queryActiveFun() {
      const self = this
      self.showLoading = true
      try {
        let res
        if (self.activityCode) {
          res = await getSignStoreActivityDetailByCode({ activityCode: self.activityCode })
        } else if (self.activityId) {
          res = await getSignStoreActivityDetail({ id: self.activityId })
        } else {
          throw new Error('活动ID或编码不存在')
        }
        if (!res || res.status !== 200) {
          throw new Error((res && res.msg) || '获取活动详情失败')
        }
        const activityData = res.data
        if (!activityData) throw new Error('活动数据为空')

        self.activityId = activityData.id
        if (activityData.activityCode) self.activityCode = activityData.activityCode
        self.ruleCode = activityData.ruleCode || null

        let pageConfig = activityData.pageConfig || {}
        if (activityData.pageConfigJson) {
          try {
            pageConfig =
              typeof activityData.pageConfigJson === 'string'
                ? JSON.parse(activityData.pageConfigJson)
                : activityData.pageConfigJson
          } catch (e) {
            console.error('解析 pageConfigJson 失败:', e)
          }
        }

        self.formData = {
          name: pageConfig.activityName || activityData.activityName || '活动名称',
          assistantName: pageConfig.assistantName || '副标题',
          ruleContent: pageConfig.ruleContent || '',
          image: getImageUrl(pageConfig.bannerImage) || pageConfig.bannerImage || getImageUrl('shop.png'),
          product: {
            image: getImageUrl(pageConfig.productImage) || pageConfig.productImage || getImageUrl('shop.png')
          }
        }

        if (pageConfig.signatureTotalNum) self.medalTotal = pageConfig.signatureTotalNum
        if (pageConfig.signatureRowNum) self.medalRowNum = pageConfig.signatureRowNum
        self.isShowSingTitle = !!pageConfig.isShowSingTitle
        self.isOpenError = !!pageConfig.isOpenError

        const rawHotspots = Array.isArray(pageConfig.hotspots) ? pageConfig.hotspots : []
        const total = Number(self.medalTotal) || 10
        const defaultDo = 'https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/images/xz2.png'
        const defaultNot = 'https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/images/xz.png'
        const defaultSize = 50
        const list = []
        for (let i = 0; i < total; i++) {
          const ex = rawHotspots[i]
          const checkType =
            ex && (ex.checkType === 'VERIFY' || ex.checkType === 'CHECKIN') ? ex.checkType : 'CHECKIN'
          let verifyCondition = null
          if (ex && ex.verifyCondition && typeof ex.verifyCondition === 'object') {
            verifyCondition = {
              needValidate: !!ex.verifyCondition.needValidate,
              conditionType:
                ex.verifyCondition.conditionType === 'TIME' ? 'TIME' : 'PREREQUISITE',
              timeStart: String(ex.verifyCondition.timeStart || '').trim(),
              timeEnd: String(ex.verifyCondition.timeEnd || '').trim(),
              prerequisiteIndexes: Array.isArray(ex.verifyCondition.prerequisiteIndexes)
                ? ex.verifyCondition.prerequisiteIndexes
                : []
            }
          }
          list.push({
            index: ex && ex.index != null ? ex.index : i + 1,
            doSignImg: ex && ex.doSignImg ? ex.doSignImg : defaultDo,
            notSignImg: ex && ex.notSignImg ? ex.notSignImg : defaultNot,
            errignImg: ex && ex.errignImg ? ex.errignImg : defaultNot,
            size: ex && ex.size != null && ex.size !== '' ? Number(ex.size) : defaultSize,
            title: ex && ex.title != null && ex.title !== '' ? String(ex.title) : '',
            checkType,
            verifyCondition
          })
        }
        self.hotspots = list

        const imgDo = {}
        const imgNot = {}
        const imgErr = {}
        const imgStyles = {}
        for (let i = 0; i < list.length; i++) {
          imgDo[i] = list[i].doSignImg || self.defaultMedalImgDo
          imgNot[i] = list[i].notSignImg || self.defaultMedalImgNot
          imgErr[i] = list[i].errignImg || list[i].notSignImg || self.defaultMedalImgNot
          const size =
            list[i].size != null && list[i].size !== '' ? Number(list[i].size) : defaultSize
          imgStyles[i] = { width: size + 'px', height: size + 'px' }
        }
        self.medalImgDo = imgDo
        self.medalImgNot = imgNot
        self.medalImgErr = imgErr
        self.medalImgStyles = imgStyles

        await self.loadUserRecord()
        await self.loadCheckedPointsWithStatus()
        self.showLoading = false
      } catch (error) {
        self.showLoading = false
        Toast(error.message || '加载活动失败')
      }
    },
    async loadUserRecord() {
      try {
        const params = {}
        if (this.activityId) params.activityId = this.activityId
        else if (this.activityCode) params.activityCode = this.activityCode
        if (this.h5Uid) params.h5Uuid = this.h5Uid
        else return
        const res = await getOrCreateUserRecordH5(params)
        if (res && res.status === 200 && res.data) {
          const userRecord = res.data
          this.activityUserId = userRecord.id || null
          this.completedCount = userRecord.completedCount || 0
          this.verifyableCount = userRecord.verifyableCount || 0
        }
      } catch (error) {
        this.activityUserId = null
        this.completedCount = 0
        this.verifyableCount = 0
      }
    },
    async loadCheckedPointsWithStatus() {
      if (!this.activityUserId) return
      try {
        const res = await getCheckedPointsWithStatus({ activityUserId: this.activityUserId })
        const list =
          res && res.data ? res.data : res && res.data !== undefined ? [res.data] : []
        const map = {}
        if (Array.isArray(list)) {
          list.forEach(item => {
            const idx = item.pointIndex != null ? item.pointIndex : item.point_index
            const status =
              item.isSignSuccess != null ? item.isSignSuccess : item.is_sign_success
            if (idx != null) map[idx] = status != null ? status : 1
          })
        }
        this.pointStatusMap = map
      } catch (e) {
        this.pointStatusMap = {}
      }
    },
    isMedalClickable(medalIndex) {
      return this.checkCanCheckinAtPoint(medalIndex).ok
    },
    checkCanCheckinAtPoint(medalIndex) {
      const hotspot = this.hotspots[medalIndex]
      if (!hotspot) return { ok: true }
      const cond = hotspot.verifyCondition
      if (!cond || !cond.needValidate) return { ok: true }
      if (cond.conditionType === 'TIME') {
        const now = moment()
        const start = cond.timeStart ? moment(cond.timeStart) : null
        const end = cond.timeEnd ? moment(cond.timeEnd) : null
        if (start && now.isBefore(start)) {
          return { ok: false, msg: '当前未到可打卡时间，开始时间：' + (cond.timeStart || '') }
        }
        if (end && now.isAfter(end)) {
          return { ok: false, msg: '已过可打卡时间，结束时间：' + (cond.timeEnd || '') }
        }
        return { ok: true }
      }
      if (cond.conditionType === 'PREREQUISITE') {
        const indexes = cond.prerequisiteIndexes || []
        const missing = indexes.filter(idx => this.pointStatusMap[idx] !== 1)
        if (missing.length > 0) {
          return { ok: false, msg: '请先完成勋章 ' + missing.join('、') + ' 后再打卡' }
        }
        return { ok: true }
      }
      return { ok: true }
    },
    showcheckInBoxFun(medalIndex) {
      const check = this.checkCanCheckinAtPoint(medalIndex)
      if (!check.ok) {
        Toast(check.msg || '当前不满足打卡条件')
        return
      }
      const hotspot = this.hotspots[medalIndex]
      const pointIndex =
        hotspot && hotspot.index != null ? hotspot.index : medalIndex + 1
      this.currentCheckinMedalIndex = pointIndex
      this.isVerifying = hotspot && hotspot.checkType === 'VERIFY'
      if (this.isOpenError) {
        this.chosenSignSuccess = null
        this.showSuccessFailChoice = true
      } else {
        this.showcheckInBox = true
        this.clearCanvasOnOpen()
      }
    },
    getMedalStatus(medalIndex) {
      if (!this.hotspots[medalIndex]) return 0
      const pointIndex = this.hotspots[medalIndex].index
      return this.pointStatusMap[pointIndex] || 0
    },
    onChooseSignSuccess(value) {
      this.chosenSignSuccess = value
      this.showSuccessFailChoice = false
      this.showcheckInBox = true
      this.clearCanvasOnOpen()
    },
    handleVerify() {
      if (this.verifyableCount <= 0) {
        Toast('没有可核销的次数')
        return
      }
      if (!this.activityUserId) {
        Toast('用户活动记录不存在，无法核销')
        return
      }
      this.isVerifying = true
      this.showcheckInBox = true
      this.clearCanvasOnOpen()
    },
    handleOverlayClick() {
      this.showcheckInBox = false
      if (this.isOpenError) this.chosenSignSuccess = null
      if (this.retryTimer) {
        clearTimeout(this.retryTimer)
        this.retryTimer = null
      }
    },
    clearCanvasOnOpen() {
      this.lastTouchPoints = null
      this.lastValidFourPoints = null
      this.hasSubmittedThisGesture = false
      if (this.retryTimer) {
        clearTimeout(this.retryTimer)
        this.retryTimer = null
      }
      this.retryCount = 0
    },
    handleTouchStart(event) {
      const touchCount = event.touches ? event.touches.length : 0
      if (touchCount === 0 || this.checking) return
      const el = this.$refs.canvasWrap
      if (!el) return
      const rect = el.getBoundingClientRect()
      if (!rect || rect.width === 0 || rect.height === 0) {
        if (touchCount === 4) Toast('无法获取打卡区域位置，请重试')
        return
      }
      const touchPoints = []
      for (let i = 0; i < event.touches.length; i++) {
        const t = event.touches[i]
        const x = t.clientX - rect.left
        const y = t.clientY - rect.top
        const standardX = Math.round((x / rect.width) * this.standardWidth)
        const standardY = Math.round((y / rect.height) * this.standardHeight)
        touchPoints.push([standardX, standardY])
      }
      this.lastTouchPoints = touchPoints
      if (touchCount === 4) this.lastValidFourPoints = touchPoints
      if (touchCount === 4) {
        if (this.checking || this.hasSubmittedThisGesture) return
        this.hasSubmittedThisGesture = true
        this.doValidateSeal(touchPoints)
      }
    },
    handleTouchMove(event) {
      const touchCount = event.touches ? event.touches.length : 0
      if (touchCount === 0 || this.checking) return
      const el = this.$refs.canvasWrap
      if (!el) return
      const rect = el.getBoundingClientRect()
      if (!rect || rect.width === 0 || rect.height === 0) return
      const touchPoints = []
      for (let i = 0; i < event.touches.length; i++) {
        const t = event.touches[i]
        const x = t.clientX - rect.left
        const y = t.clientY - rect.top
        const standardX = Math.round((x / rect.width) * this.standardWidth)
        const standardY = Math.round((y / rect.height) * this.standardHeight)
        touchPoints.push([standardX, standardY])
      }
      this.lastTouchPoints = touchPoints
      if (touchCount === 4) this.lastValidFourPoints = touchPoints
      if (touchCount === 4) {
        if (this.checking || this.hasSubmittedThisGesture) return
        this.hasSubmittedThisGesture = true
        this.doValidateSeal(touchPoints)
      }
    },
    handleTouchEnd(event) {
      const touchCount = event.touches ? event.touches.length : 0
      if (touchCount === 0) {
        this.hasSubmittedThisGesture = false
        if (
          !this.checking &&
          !this.retryTimer &&
          this.lastValidFourPoints &&
          this.lastValidFourPoints.length === 4
        ) {
          this.hasSubmittedThisGesture = true
          this.doValidateSeal(this.lastValidFourPoints)
        }
      }
    },
    scheduleRetry(touchArr) {
      if (this.retryTimer) clearTimeout(this.retryTimer)
      if (this.retryCount >= this.maxAutoRetry || !touchArr || touchArr.length !== 4) return
      this.retryCount++
      this.retryTimer = setTimeout(() => {
        this.retryTimer = null
        this.doValidateSeal(touchArr)
      }, 2500)
    },
    async doValidateSeal(touchArr) {
      if (this.checking) return
      this.checking = true
      try {
        if (!this.ruleCode) {
          Toast('活动规则编码不存在，无法打卡')
          this.checking = false
          return
        }
        if (!this.activityUserId) await this.loadUserRecord()
        if (!this.activityUserId) {
          Toast('用户活动记录不存在，无法打卡')
          this.checking = false
          return
        }
        const validateData = {
          ruleCode: this.ruleCode,
          touchPoints: touchArr,
          activityUserId: this.activityUserId,
          operationType: this.isVerifying ? 'VERIFY' : 'CHECKIN',
          isSignSuccess: this.chosenSignSuccess != null ? this.chosenSignSuccess : 1,
          pointIndex: this.isVerifying
            ? null
            : this.currentCheckinMedalIndex != null
              ? this.currentCheckinMedalIndex
              : null
        }
        const validateRes = await validateSeal(validateData)
        const result =
          validateRes && validateRes.data !== undefined ? validateRes.data : validateRes
        if (!result || !result.matched) {
          this.checking = false
          this.scheduleRetry(touchArr)
          return
        }
        this.retryCount = 0
        this.load = true
        this.showcheckInBox = false
        if (this.isOpenError) this.chosenSignSuccess = null
        this.checking = false
        await this.loadUserRecord()
        await this.loadCheckedPointsWithStatus()
        if (this.isVerifying) {
          Toast.success('核销成功')
          this.isVerifying = false
        }
        this.currentCheckinMedalIndex = null
        setTimeout(() => {
          this.load = false
        }, 2000)
      } catch (error) {
        this.scheduleRetry(touchArr)
      } finally {
        this.checking = false
        this.load = false
      }
    }
  }
}
</script>

<style scoped lang="less">
.page-event-details {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 40px;
}
.banne-img {
  width: 100%;
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.p030 {
  padding: 0 12px;
}
.title-row {
  text-align: center;
  padding: 16px 0;
  .h1 {
    font-size: 20px;
    font-weight: bold;
    color: #333;
  }
  .sub {
    font-size: 14px;
    color: #666;
    margin-top: 4px;
  }
  .line {
    width: 40px;
    height: 2px;
    background: #333;
    margin: 12px auto;
  }
  .des {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    white-space: pre-wrap;
  }
}
.medal-list {
  display: grid;
  gap: 12px;
  padding: 16px 12px;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .medal-img {
      border-radius: 50%;
      object-fit: contain;
      &.medal-locked {
        opacity: 0.6;
      }
    }
    .medal-title {
      font-size: 12px;
      color: #666;
      margin-top: 4px;
    }
  }
}
.dk-activity-total {
  margin: 12px 12px 24px;
  padding: 12px 16px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  .icon {
    width: 48px;
    height: 48px;
    margin-right: 12px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .txt {
    flex: 1;
    font-size: 14px;
    color: #333;
    .b {
      font-weight: bold;
      color: #1989fa;
    }
    .ljsy {
      margin-left: 8px;
      color: #1989fa;
      cursor: pointer;
    }
  }
  .link-arrow {
    width: 8px;
    height: 8px;
    border-right: 2px solid #999;
    border-bottom: 2px solid #999;
    transform: rotate(-45deg);
  }
}
.fc-bet {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fcc-h {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fcc {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex1 {
  flex: 1;
}

.checkin-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.success-fail-choice-pop {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  min-width: 260px;
  .choice-title {
    font-size: 16px;
    margin-bottom: 16px;
  }
  .choice-btns {
    display: flex;
    gap: 12px;
  }
  .choice-btn {
    padding: 10px 24px;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
  }
  .choice-btn-success {
    background: #07c160;
    color: #fff;
  }
  .choice-btn-fail {
    background: #ee0a24;
    color: #fff;
  }
}
.checkin-pop {
  width: 100%;
  max-width: 640px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.canvas-container {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.canvas-wrap {
  width: min(100vw, 600px);
  height: min(100vw, 600px);
  border: 2px solid #ddd;
  border-radius: 8px;
  background: #f5f5f5;
  box-sizing: border-box;
  touch-action: none;
}
.checkin-hint {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-wrapper {
  flex-direction: column;
}
.loading-spinner {
  position: relative;
  width: 60px;
  height: 60px;
  .spinner-ring {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 3px solid transparent;
    border-top-color: #1989fa;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  .spinner-ring:nth-child(2) {
    animation-delay: 0.15s;
    border-top-color: #07c160;
  }
  .spinner-ring:nth-child(3) {
    animation-delay: 0.3s;
    border-top-color: #ff976a;
  }
  .spinner-logo {
    position: absolute;
    inset: 50%;
    transform: translate(-50%, -50%);
    width: 28px;
    height: 28px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.loading-text {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.seal-loading {
  .seal-circle-outer {
    width: 80px;
    height: 80px;
    .circle {
      width: 100%;
      height: 100%;
      object-fit: contain;
      animation: spin 2s linear infinite;
    }
  }
  .seal-logo-inner {
    position: absolute;
    width: 40px;
    height: 40px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.fade-in-up {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.3s ease, transform 0.3s ease;
  &.animate-in {
    opacity: 1;
    transform: translateY(0);
  }
  &.delay-1 {
    transition-delay: 0.1s;
  }
  &.delay-2 {
    transition-delay: 0.2s;
  }
  &.delay-3 {
    transition-delay: 0.3s;
  }
}
</style>
